import './card_heading_component.scss'
import { Controller } from 'stimulus'
import { tick } from 'relation-map/tick'
import { unclick } from 'relation-map/action'

export default class extends Controller {
  close = (): void => {
    unclick()
    tick()
  }
}
